import NewMessage from "./NewMessage";

export default NewMessage;
